import React from 'react';
import QRCode from 'qrcode';
import style from './index.less';
// import { transform, i18n, lan } from '../../unit/const';
import { transform } from '../../unit/const';
import { isMobile } from '../../unit';


export default class Guide extends React.Component {
  constructor() {
    super();
    this.state = {
      isMobile: isMobile(),
      QRCode: '',
    };
  }
  componentWillMount() {
    if (this.state.isMobile) {
      return;
    }
    QRCode.toDataURL(location.href, { margin: 1 })
        .then(dataUrl => this.setState({ QRCode: dataUrl }));
  }
  shouldComponentUpdate(state) {
    if (state.QRCode === this.state.QRCode) {
      return false;
    }
    return true;
  }
  render() {
    if (this.state.isMobile) {
      return (
        null
      );
    }
    return (
      <div style={{ display: this.state.isMobile ? 'none' : 'block' }}>
        <div className={`side-nav-arrows ${style.guide} ${style.right}`}>
          <div className={style.up}>
            <em style={{ [transform]: 'translate(0,-3px) scale(1,2)' }} />
          </div>
          <div className={style.left}>
            <em style={{ [transform]: 'translate(-7px,3px) rotate(-90deg) scale(1,2)' }} />
          </div>
          <div className={style.down}>
            <em style={{ [transform]: 'translate(0,9px) rotate(180deg) scale(1,2)' }} /></div>
          <div className={style.right}>
            <em style={{ [transform]: 'translate(7px,3px)rotate(90deg) scale(1,2)' }} />
          </div>
        </div>
        <div className={`${style.guide} ${style.left}`}>
          <div className={`side-btn ${style.space}`}>SPACE</div>
        </div>
        <div className={`side-help ${style.guide} ${style.qr}`}>
          <h2>👾 Free Tetris Online 👾</h2>
          <br />
          <p>
            "Good Old Tetris" is a tribute to the good old tetris game,
            and it is not an affiliate to the TETRIS company.
            This game is <a href="https://github.com/chvin/react-tetris">Open Source</a>

            <br />
            <br />
            As being open source, you can&nbsp;
            <strong>play online tetris free and unblocked</strong> here.
          </p>
          <div id="promo-left">
            <div className="privacy-policy">
              <a href="/privacy.html">Privacy Policy</a>
            </div>
            <a href="https://2048game.com/">
              You may also enjoy<br/>
              the 2048 Game
              <br />
              <br />
              <img src="/2048-icon.png" alt="2048 Game Icon" />
            </a>
          </div>
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/guide/index.js